import { render, staticRenderFns } from "./UserEditTabSocial.vue?vue&type=template&id=71beb8d7&scoped=true&"
import script from "./UserEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./UserEditTabSocial.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabSocial.vue?vue&type=style&index=0&id=71beb8d7&lang=scss&scoped=true&"
import style1 from "./UserEditTabSocial.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71beb8d7",
  null
  
)

export default component.exports